
<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pa-1 py-0">
        <v-text-field :prepend-icon="with_icons && 'mdi-map' || null" rounded outlined dense
          :rules="validate_form? required : []" 
          v-model="address.zip" 
          :label="$t('addresses_labels.zip')"
          v-mask="'#####-###'" 
          @input="fetchZip(address.zip)" 
          :loading='loading_zip' :readonly="loading_zip"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="5" class="pa-1 py-0">
        <v-text-field :prepend-icon="with_icons && 'mdi-sign-direction' || null" rounded outlined dense
          v-model="address.street" 
          :rules="validate_form? required : []" 
          :label="$t('addresses_labels.street')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="pa-1 py-0">
        <v-text-field :prepend-icon="with_icons && 'mdi-numeric-9-plus-box-multiple-outline' || null" rounded outlined dense
          :rules="validate_form? required : []" 
          v-model="address.number" 
          :label="$tc('addresses_labels.number')"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="5" class="pa-1 py-0">
        <v-text-field :prepend-icon="with_icons && 'mdi-map-marker' || null" rounded outlined dense
          :rules="validate_form? required : []" 
          v-model="address.district" 
          :label="$t('addresses_labels.district')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="5" class="pa-1 py-0">
        <v-text-field :prepend-icon="with_icons && 'mdi-city' || null" rounded outlined dense
          :rules="validate_form? required : []" 
          v-model="address.city" 
          :label="$t('addresses_labels.city')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="2" class="pa-1 py-0">
        <v-text-field :prepend-icon="with_icons && 'mdi-map-outline' || null" rounded outlined dense
          :rules="validate_form? required : []" 
          v-model="address.state" 
          :label="$t('addresses_labels.state')"
        ></v-text-field>
      </v-col>
    </v-row>
    
    <v-text-field :prepend-icon="with_icons && 'mdi-plus-box' || null" rounded outlined dense
      v-if="false"
      v-model="address.complement" 
      :label="$t('addresses_labels.complement')"
    ></v-text-field>


  </div>
</template>

<script>
import { mapActions } from 'vuex'
import cep from 'cep-promise'
import validations from '@/mixins/validations'

export default {
  name: 'AddressForm',
  props: {
    validate_form: {
      type: Boolean,
      default: () => false
    },
    with_icons: {
      type: Boolean,
      deafult: false,
    },
    address: {
      type: Object
    },
  },
  mixins: [ validations ],
  data() {
    return {
      loading_zip: false
    }
  },
  methods: {
    fetchZip(zip) {
      if(!this.loading_zip && (/^[0-9]{8}$/.test(zip.replace(/[.-]/g,'')))) {
        this.loading_zip = true
        cep(zip.replace(/[.-]/g,'')).then(endereco => {
          // console.log({endereco});
          const { street, neighborhood, city, state } = endereco
          // this.address= {...this.address, ...endereco}
          // this.address.zip
          this.address.street = street
          this.address.district = neighborhood
          this.address.city = city
          this.address.state = state
        }).catch((error) => {
          const noti = {
            type: 'error',
            msg: 'CEP não encontrado'
          }
          this.addNotification(noti)
          this.address.street = null
          this.address.district = null
          this.address.city = null
          this.address.state = null
          console.log(error);
        }).finally(()=>{
          this.loading_zip = false
        })
      }
      else {
        // console.log('erro no cep');
      }
    },
    ...mapActions({
      addNotification: 'Notification/add'
      // function: 'Module/action'
    })
  },
  /*computed: {
    name() {
      return null
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },*/
}
</script>

<style scoped>

</style>
